import { IAccountMappingDataAutoFilled } from '../interfaces/IAccountMappingDataAutoFilled.interface';
import { IAccountMappingDataMapped } from '../interfaces/IAccountMappingDataMapped.interface';
import { IAccountMappingDataNew } from '../interfaces/IAccountMappingDataNew.interface';

export type AccountMappingData = IAccountMappingDataMapped | IAccountMappingDataNew | IAccountMappingDataAutoFilled;
